import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs-compat/Observable'
import { QueryModelApiConfiguration } from '../apiConfiguration';
import { AdmissionSearchFilter } from '../../../models/queryModel';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
@Injectable()
export class SearchPatientHasAdmissionService extends ServiceBase {

    private actionUrl: string;
    private _get: string;
    private _action: string;

    constructor(private _http: HttpClient, private _configuration: QueryModelApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._get = this.actionUrl + _configuration.searchPatientHasAdmission.url;
    }

    getSearchResult = (data: AdmissionSearchFilter): Observable<any> => {

        let queryString: string = '';
        queryString += '?patientCode=';
        if (data.patientCode)
            queryString += data.patientCode;
        queryString += '&patientName=';
        if (data.patientName)
            queryString += data.patientName;
        queryString += '&nationalID=';
        if (data.nationalID)
            queryString += data.nationalID;
        queryString += '&telCode=';
        if (data.phoneNumber)
            queryString += data.phoneNumber;
        queryString += '&admissionDate=';
        if (data.admissionDate)
            queryString += data.admissionDate.toLocaleDateString();
        queryString += '&admissionDoctor=';
        if (data.admissionDoctor)
            queryString += data.admissionDoctor;
        queryString += '&section=';
        if (data.section)
            queryString += data.section;
        queryString += '&hasAdmission=';
        if (data.hasAdmission)
            queryString += data.hasAdmission;
        return this._http.get<any>(this._get + queryString);
    }
}
